<section class="category list pt-4">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="product-box">
          <div class="cat-box d-flex justify-content-end">
            <div style="display: flex!important;padding-right: 25px;">
              <!--<div class="sortby" style="margin-right: 20px;">
                <span>Sort By</span>
                <select class="sort-box">
                  <option>Position</option>
                  <option>Name</option>
                  <option>Price</option>
                  <option>Rating</option>
                </select>
              </div>-->
              <div class="show-item" style="margin-right: 20px;">
                <span>Mostrar</span>
                <select class="show-box" #selectItems>
                  <option selected>20</option>
                  <option>30</option>
                  <option>50</option>
                </select>
              </div>
              <!-- <div class="page">
                <p>Page {{pageNo$ | async}} of {{totalPages$ | async}}</p>
              </div> -->
              <div  class="page">
                <p>Mostrando {{count$ | async}} de {{totalData$ | async}} resultados</p>
              </div>
            </div>

          </div>
          <div class="tab-content">
            <div class="tab-pane active">
              <div class="row">
                <ng-container *ngIf="isLoading$ | async ; else template">
                  <div *ngFor="let product of [1,2,3,4,5,6,7,8]" style="display:flex;" class="col-lg-3 col-md-4 col-6">
                      <div class="tab-item w-100">
                        <div class="tab-img">
                          <ngx-skeleton-loader animation="progress" animation="true" appearance="line"
                                               [theme]="{ height: 'auto',background: '#f1f1f1', 'border-radius': '15px', 'padding-bottom': '80%'}">
                          </ngx-skeleton-loader>
                        </div>
                        <div class="tab-heading d-flex justify-content-center">
                          <ngx-skeleton-loader animation="progress" appearance="line"
                                               [theme]="{ margin: '-15px 0 0 0', width: '160px', height: '28px',background: '#f1f1f1'}">
                          </ngx-skeleton-loader>
                        </div>
                      </div>
                    </div>
                </ng-container>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<section *ngIf="items$ | async" class="d-flex justify-content-center p-0 paginated">
  <ngb-pagination [pageSize]="pageSize$ | async" [collectionSize]="totalData$ | async" (pageChange)="pageChange($event)" [page]="pageNo$ | async"></ngb-pagination>
</section>
<ng-template #template>
  <ng-container *ngFor="let category of items$ | async; let index = index;">
    <div style="display:flex;" class="col-lg-3 col-md-4 col-6">
      <div class="tab-item w-100">
        <div class="tab-img">
          <ngx-skeleton-loader [hidden]="category.loaded" animation="progress" appearance="line"
                               [theme]="{ background: '#f1f1f1', 'border-radius': '15px', 'padding-bottom': '80%'}">
          </ngx-skeleton-loader>

          <img (click)="categoryAction(category)" [hidden]="!category.loaded" class="main-img img-fluid rounded-xl category-img cursor-pointer"
               src="{{category.pictures.length>0?category.pictures[0].previewUrl:'assets/xemart/images/notImg.png'}}"
               (load)="category.loaded=true" (click)="categoryAction(category)">

        </div>
        <!-- <div class="tab-heading">
          <p class="text-center">
            <a *ngIf="!category.hasChildren" routerLink="../../tienda-online-cuba/{{getSlug(category.code)}}">{{category.name}}</a>
            <a *ngIf="category.hasChildren" (click)="searchChildrenCategory(category.code)">{{category.name}}</a></p>
        </div> -->
        <div class="tab-heading">
          <p class="text-center">
            <a (click)="categoryAction(category)">{{category.name}}</a></p>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

